import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, skip} from 'rxjs';
import {ApiService} from './api.service';
import {environment} from "environments/environment";
import {FuseConfigService} from "@fuse/services/config";

@Injectable({providedIn: 'root'})
export class UserPreferenceService {

    // Private
    private _userAppearanceConfig: BehaviorSubject<any | null> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(
        private _apiService: ApiService,
        private _fuseConfigService: FuseConfigService,
    ) {
        // Automatically save configuration changes to local storage
        // skip(1) to avoid overwriting the saved config with the app startup default
        this._fuseConfigService.config$.pipe(skip(1)).subscribe((config: any) => {
            localStorage.setItem('admin-appearance-config', JSON.stringify(config));
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
    get appearanceConfig$(): Observable<any> {
        return this._userAppearanceConfig.asObservable();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    getAppearanceConfig(): Observable<any> {
        if (this._userAppearanceConfig.value) {
            return of(this._userAppearanceConfig.value);
        }

        // Base config with system preference default
        let config = { ...environment.appearance, scheme: 'auto' };

        // Attempt to load previously saved config from local storage
        try {
            const savedConfig = localStorage.getItem('admin-appearance-config');
            if (savedConfig) {
                config = { ...config, ...JSON.parse(savedConfig) };
            }
        } catch (e) {
            console.error('Failed to parse appearance configuration from local storage', e);
        }

        this._fuseConfigService.config = config;
        this._userAppearanceConfig.next(config);
        return of(config);
    }

}
